import { maskitoDateOptionsGenerator } from '@maskito/kit';
var DATE_MASK_FORMAT = 'MM/dd/yyyy';
var DATE_MASK_WITHOUT_YEAR_FORMAT = 'MM/dd';
var DATE_MASK = maskitoDateOptionsGenerator({
    mode: 'mm/dd/yyyy',
    separator: '/',
});
var DATE_MASK_WITHOUT_YEAR = maskitoDateOptionsGenerator({
    mode: 'mm/dd',
    separator: '/',
});
export { DATE_MASK_FORMAT, DATE_MASK_WITHOUT_YEAR_FORMAT, 
//,
DATE_MASK, DATE_MASK_WITHOUT_YEAR, };
